module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.isLoading) ? _c('loading', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "columns m-b-10 m-t-10 is-gapless"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "column is-7",
    class: {
      'm-r-10': _vm.$mq.resize && _vm.$mq.above(_vm.$mv.tablet),
        'm-b-10': _vm.$mq.resize && _vm.$mq.below(_vm.$mv.tablet),
    }
  }, [_c('card', {
    attrs: {
      "red": true,
      "isButtonHiddenMobile": true,
      "subtitle": _vm.solutions,
      "background": _vm.solutions_image,
      "title": 'solutions',
      "to": ("solutions/" + _vm.solutionsInitialRoute),
      "height": "70vh"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "columns is-marginless is-gapless flex-column"
  }, [_c('div', {
    staticClass: "column m-b-10",
    class: {
      'm-b-10': _vm.$mq.resize && _vm.$mq.below(_vm.$mv.tablet)
    }
  }, [_c('card', {
    attrs: {
      "red": true,
      "isButtonHiddenMobile": true,
      "subtitle": _vm.about,
      "background": _vm.about_image,
      "title": 'about us',
      "to": "about",
      "height": "calc(35vh - 5px)"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column",
    class: {
      'm-b-10': _vm.$mq.resize && _vm.$mq.below(_vm.$mv.tablet)
    }
  }, [_c('card', {
    attrs: {
      "red": true,
      "isButtonHiddenMobile": true,
      "subtitle": _vm.capabilities,
      "background": _vm.capabilities_image,
      "title": 'capabilities',
      "to": ("capabilities/" + _vm.capabilitiesInitialRoute),
      "height": "calc(35vh - 5px)"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-marginless is-gapless"
  }, [_c('div', {
    staticClass: "column is-5",
    class: {
      'm-r-10': _vm.$mq.resize && _vm.$mq.above(_vm.$mv.tablet),
        'm-b-10': _vm.$mq.resize && _vm.$mq.below(_vm.$mv.tablet),
    }
  }, [_c('card', {
    attrs: {
      "red": true,
      "isButtonHiddenMobile": true,
      "subtitle": _vm.contact,
      "background": _vm.contact_image,
      "title": 'contact us',
      "to": "contact",
      "height": "70vh"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column m-b-10",
    class: {
      'm-b-10': _vm.$mq.resize && _vm.$mq.below(_vm.$mv.tablet)
    }
  }, [_c('card', {
    attrs: {
      "red": true,
      "isButtonHiddenMobile": true,
      "top": true,
      "subtitle": _vm.careers,
      "background": _vm.careers_image,
      "title": 'careers',
      "to": "careers",
      "height": "70vh"
    }
  })], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vanish"
  }, [_c('p', [_vm._v("Lorem, ipsum dolor.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4aa0d29e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/homepage/homeCards.vue
// module id = 1142
// module chunks = 1